import styled, { keyframes } from 'styled-components';
import { Box } from '@mui/material';

const pulse = keyframes`
  0% {
    opacity: 0.6;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.2);
  }
  100% {
    opacity: 0.6;
    transform: scale(1);
  }
`;

const blink = keyframes`
  0%, 50% {
    opacity: 1;
  }
  51%, 100% {
    opacity: 0.3;
  }
`;


export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px;

  .infos {
    display: flex;
    flex-direction: column;
    gap: 16px;

    h3 {
      color: #353535;
      font-family: 'Inter';
      font-style: normal;
      font-weight: 600;
      font-size: 1.5rem;
      line-height: 29px;
    }
  }

  @media (max-width: 768px) {
    padding: 16px;

    .infos h3 {
      font-size: 1.5rem;
    }
  }
`;

export const LoadingContainer = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  flex-direction: column;
  gap: 16px;
`;

export const AccordionTitleContainer = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 12px;
`;

export const DepotTitle = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const PulsingDot = styled(Box)`
  width: 8px;
  height: 8px;
  background-color: #ff9800;
  border-radius: 50%;
  animation: ${pulse} 2s ease-in-out infinite;
`;

export const BlinkingIndicator = styled(Box)`
  width: 6px;
  height: 6px;
  background-color: #4caf50;
  border-radius: 50%;
  animation: ${blink} 1.5s infinite;
  margin-left: 4px;
`;

export const ProcessingText = styled(Box)`
  font-size: 0.75rem;
  color: #ff9800;
  font-weight: 500;
  animation: ${blink} 2s infinite;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;


export const EmptyStateContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  text-align: center;
  gap: 16px;

  h3 {
    color: #666;
    font-size: 1.25rem;
    margin: 0;
  }

  p {
    color: #999;
    margin: 0;
  }
`;
